import { useEffect, useRef, useState } from 'react';

export const useWidth = <T extends HTMLElement>() => {
  const ref = useRef<T | null>(null);

  const [width, setWidth] = useState<number | null>(null);

  useEffect(() => {
    const checkSize = () => {
      if (ref.current) {
        const width = ref.current.offsetWidth;
        setWidth(width);
      }
    };

    checkSize();
    window.addEventListener('resize', checkSize);
    return () => window.removeEventListener('resize', checkSize);
  }, []);

  return { ref, width };
};
